import React, { createContext, useContext, useState, useEffect } from 'react';
import { 
  signInWithEmailAndPassword, 
  signOut, 
  onAuthStateChanged 
} from 'firebase/auth';
import { auth, db } from '../config/firebase';
import { doc, getDoc } from 'firebase/firestore';

const AuthContext = createContext({});

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        setCurrentUser(user);
        // Kullanıcının admin olup olmadığını kontrol et
        try {
          const userDoc = await getDoc(doc(db, 'users', user.uid));
          if (userDoc.exists()) {
            const userData = userDoc.data();
            // Boolean kontrolü - hem true hem de "true" string'ini kabul et
            setIsAdmin(userData.isAdmin === true || userData.isAdmin === "true");
          } else {
            setIsAdmin(false);
          }
        } catch (error) {
          console.error('Error checking admin status:', error);
          setIsAdmin(false);
        }
      } else {
        setCurrentUser(null);
        setIsAdmin(false);
      }
      setLoading(false);
    });

    return unsubscribe;
  }, []);

  const login = async (email, password) => {
    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      // Kullanıcının admin olup olmadığını kontrol et
      try {
        const userDoc = await getDoc(doc(db, 'users', userCredential.user.uid));
        console.log('User UID:', userCredential.user.uid);
        console.log('Document exists:', userDoc.exists());
        if (userDoc.exists()) {
          const userData = userDoc.data();
          console.log('User data:', userData);
          console.log('isAdmin value:', userData.isAdmin);
          console.log('isAdmin type:', typeof userData.isAdmin);
          // Boolean kontrolü - hem true hem de "true" string'ini kabul et
          const adminStatus = userData.isAdmin === true || userData.isAdmin === "true";
          console.log('Admin status:', adminStatus);
          setIsAdmin(adminStatus);
          return { success: true, user: userCredential.user, isAdmin: adminStatus };
        } else {
          console.log('Document does not exist for UID:', userCredential.user.uid);
          setIsAdmin(false);
          return { success: true, user: userCredential.user, isAdmin: false };
        }
      } catch (error) {
        console.error('Error checking admin status:', error);
        setIsAdmin(false);
        return { success: true, user: userCredential.user, isAdmin: false };
      }
    } catch (error) {
      return { success: false, error: error.message };
    }
  };

  const logout = async () => {
    try {
      await signOut(auth);
      return { success: true };
    } catch (error) {
      return { success: false, error: error.message };
    }
  };

  const value = {
    currentUser,
    isAdmin,
    login,
    logout,
    loading
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
};

